const doc = [({"zh_tw":({"adminConstantHotelPushMessageGroupPlatformType":({"allPlatforms":"所有平台", "line":"LINE"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;